export default "__VITE_ASSET__CWesN6tb__"